import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // Arrow icons for navigation
import { Link } from 'react-router-dom'; // Make sure you have react-router-dom installed

// Card component
const Card = ({ title, description, hovered, onMouseEnter, onMouseLeave }) => {
    return (
        <div
            className="card"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className="card-content">
                <h3 style={{ display: hovered ? 'none' : 'block', color: '#fff', fontSize: "15px", textAlign: 'left' }}>{title}</h3>
                <p style={{ display: hovered ? 'none' : 'block ', color: '#fff',marginTop:'10px' }}>{description}</p>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexGrow: 1,
                    paddingTop: '10px',
                }}
            >
                <Link
    to="#" // Change this to your target page URL
    style={{
        color: 'rgb(244 207 48)',
        textDecoration: 'none',
        fontSize: '16px',
        display: 'inline-flex',
        textAlign: 'left',
        cursor: 'pointer',
        padding: '8px 16px', // Adding padding for better size control
        border: '2px solid rgb(244 207 48)', // Add border
        borderRadius: '12px', // Set border radius for rounded corners
        marginTop: '10px', // Optional: Add margin for spacing
    }}
>
    Learn More <span style={{ marginLeft: '5px' }}>→</span>
</Link>

            </div>

            <style jsx>{`
                .card {
                    width: 350px;
                    height: 250px;
                    padding: 20px;
                    margin: 10px;
                    border-radius: 8px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1), 0 6px 24px rgba(0, 0, 0, 0.1);
                    text-align: center;
                    background-color: #24293A;
                    transition: transform 0.3s ease, background-color 0.3s ease;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                }

                .card-content {
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }

                .card:hover {
                    transform: scale(1.05);
                    background-color: #038499;
                    color: white;
                }

                h3 {
                    font-size: 22px;
                    margin: 0;
                }

                p {
                    font-size: 16px;
                    color: #fff;
                }

                .learn-more-btn {
                    margin-top: 10px;
                    padding: 8px 16px;
                    background-color: #038499;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                }

                .learn-more-btn:hover {
                    background-color: #027180;
                }
            `}</style>
        </div>
    );
};


// Main component with Slick Slider and Auto-scrolling functionality
const CasestudiesSecondcards = () => {
    const [hovered, setHovered] = useState(null); // Track the hovered card
    const sliderRef = useRef(null); // Ref to control slider programmatically

    // Settings for the slick slider with auto-scrolling enabled
    const sliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    // Function to manually scroll to the next slide
    const goToNextSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext();
        }
    };

    // Function to manually scroll to the previous slide
    const goToPrevSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPrev();
        }
    };

    return (
        <div className="app-container" style={{ background: '#fff' }}>
            <br /><br />
            {/* Slick Slider */}
            <Slider {...sliderSettings} ref={sliderRef} className="cards-slider">
                <Card
                    title="Battery Management System in Electric Vehicles"
                    description="Engineering and R&D | Battery"
               
                 />
                <Card
                    title="Managing Scope 3 GHG Emissions in the Steel Industry"
                    description="Energy | Sustainability"
                />
                <Card
                    title="Virtual ECU Validation: Validating software without hardware prototypes"
                    description="Automotive"
                />
            </Slider>

            {/* Button Container for Manual Navigation */}
            <div className="buttons-container">
                <button onClick={goToPrevSlide} className="arrow-button prev-button">
                    <FaArrowLeft />
                </button>
                <button onClick={goToNextSlide} className="arrow-button next-button">
                    <FaArrowRight />
                </button>
            </div>

            <style jsx>{`
                .app-container {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    background-color: #f4f4f4;
                    padding: 20px;
                }

                .cards-slider {
                    margin-bottom: 40px;
                    width: 80%;
                }

                .buttons-container {
                    display: flex;
                    justify-content: center;
                    gap: 20px;
                }

                button {
                    padding: 10px 20px;
                    background-color: #11a1b0;
                    color: white;
                    border: none;
                    border-radius: 31px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                }

                button:hover {
                    background-color: #0c7f86;
                }
            `}</style>
        </div>
    );
};

export default CasestudiesSecondcards;
